import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
        <li className="flex items-center gap-1.5">
          <Link to="/" className="transition-colors hover:text-primary-700">
            首页
          </Link>
          <i className="ri-arrow-right-s-line text-foreground-300" />
        </li>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-1.5">
              {item.to && !isLast ? (
                <Link to={item.to} className="transition-colors hover:text-primary-700">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-800" : ""}>{item.label}</span>
              )}
              {!isLast ? <i className="ri-arrow-right-s-line text-foreground-300" /> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}